import styled from 'styled-components';

import { font, mixin } from '../../utils/styles';

type PropT = {
  size?: number,
  color?: string,
  avatarUrl?:string
}

export const Image = styled.div<PropT>`
  display: inline-block;
  width: ${(props?: any) => props.size}px;
  height: ${(props?: any) => props.size}px;
  border-radius: 100%;
  ${(props?: any) => mixin.backgroundImage(props.avatarUrl)}
`;

export const Letter = styled.div<PropT>`
  display: inline-block;
  width: ${(props?: any) => props.size}px;
  height: ${(props?: any) => props.size}px;
  border-radius: 100%;
  text-transform: uppercase;
  color: #fff;
  background: ${(props?: any) => props.color};
  ${font.medium}
  ${(props?: any) => font.size(Math.round(props.size / 1.7))}
  & > span {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
`;
